/**
 * Reveal Module
 * Handles scroll-triggered animations for elements with data-reveal attributes
 * Animations are triggered when elements enter the viewport
 */

const Reveal = (() => {
  const config = {
    rootMargin: '0px 0px -100px 0px', // Trigger when element is within 100px of bottom of viewport
    threshold: 0,
  };

  const animationTypes = {
    fadeIn: 'fade-in',
    slideUp: 'slide-up',
    slideDown: 'slide-down',
    slideLeft: 'slide-left',
    slideRight: 'slide-right',
    scaleUp: 'scale-up',
    zoomIn: 'zoom-in',
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const element = entry.target;
        const revealType = element.getAttribute('data-reveal');

        // Add animation class
        element.classList.add('reveal-animated');
        element.classList.add(`reveal-${revealType}`);

        // Optionally stop observing after animation is triggered
        observer.unobserve(element);
      }
    });
  }, config);

  /**
   * Initialize reveal animations for all elements with data-reveal attribute
   */
  const init = () => {
    const revealElements = document.querySelectorAll('[data-reveal]');

    revealElements.forEach((element) => {
      const revealType = element.getAttribute('data-reveal');

      // Validate reveal type
      if (!Object.values(animationTypes).includes(revealType)) {
        console.warn(
          `Invalid reveal type: "${revealType}". Use one of: ${Object.values(
            animationTypes
          ).join(', ')}`
        );
        return;
      }

      // Add initial state class
      element.classList.add('reveal-initial');

      // Start observing element
      observer.observe(element);
    });
  };

  /**
   * Destroy observer and cleanup
   */
  const destroy = () => {
    observer.disconnect();
  };

  /**
   * Get supported animation types
   */
  const getSupportedTypes = () => Object.values(animationTypes);

  /**
   * Manually trigger reveal on an element
   */
  const triggerReveal = (element) => {
    if (element && element instanceof Element) {
      element.classList.add('reveal-animated');
      const revealType = element.getAttribute('data-reveal');
      if (revealType) {
        element.classList.add(`reveal-${revealType}`);
      }
      observer.unobserve(element);
    }
  };

  return {
    init,
    destroy,
    getSupportedTypes,
    triggerReveal,
  };
})();

export default Reveal;
